import React from 'react';
import EditableText from './EditableText';

function Location({ location, setLocation }) {
  return (
    <section className="section" id="location">
      <h2 className="section-title">Location</h2>
      <EditableText value={location.description} onChange={val => setLocation({ ...location, description: val })} className="section-subtitle" html={true} />
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <a
          href="https://www.google.com/maps/search/?api=1&query=43.5698094,10.946488&query_place_id=ChIJeQPNeCoVKhMRwu2m4i6ynWU"
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
          style={{ maxWidth: '300px', display: 'inline-block', textDecoration: 'none' }}
        >
          Get Directions
        </a>
      </div>
      <img
        src="/BorgoDellaMeliana.jpeg"
        alt="Umbria"
        className="location-image"
        style={{ width: '100%', maxWidth: '600px', display: 'block', margin: '2rem auto', borderRadius: '8px' }}
      />
    </section>
  );
}

export default Location;
